import React from 'react';
import MultistorePlaceCardOrderTypes from "./MultistorePlaceCardOrderTypes";
import {MultistoreLayoutType, PlaceApi} from "../../../../services/Api/types";
import {ReactComponent as PatternIco} from "../../../../../images/backgrounds/multistore/card-place-pattern.svg";
import MultistorePlaceCardBadge from "./MultistorePlaceCardBadge";
import {ReactComponent as PhoneIco} from "../../../../../images/icons/phone.svg";
import {getFormattedPhoneNumber} from "../../../../components/Common/FormattedPhoneNumber";
import {calcPlaceDistance} from "../../utils/multistoreUtils";

interface Props {
    place: PlaceApi;
    layout: MultistoreLayoutType;
}

const MultistorePlaceCardCover = ({place, layout}: Props) => {
    const renderDistance = () => {
        if (!place.distance || layout !== MultistoreLayoutType.HOME_WITH_MAP) return <div></div>;

        const newDistance = calcPlaceDistance(place);

        return <MultistorePlaceCardBadge text={`${newDistance} km`}/>
    }

    const renderPhoneNumber = () => {
        if (!place.phone_number || layout !== MultistoreLayoutType.HOME_WITH_MAP) return <div></div>;

        return <MultistorePlaceCardBadge text={getFormattedPhoneNumber("PL", place.phone_number)} transparent
                                         icon={<PhoneIco/>}/>
    }

    return (
        <div className="place-card-cover">
            <div className={`cover-bg`}
                 style={{backgroundImage: `url("${place.cover_small}")`}}>
                {!place.cover_small && <PatternIco className="pattern-ico"/>}
            </div>
            <div className="cover-content">
                <div className="place-card-cover-top">
                    {renderDistance()}
                    <div className="d-flex align-items-center gap-2">
                        {renderPhoneNumber()}
                        <MultistorePlaceCardOrderTypes orderTypes={place.types}/>
                    </div>
                </div>
                <div className="place-card-cover-bottom">
                    {place.cover_small && <div className="bottom-blur"/>}
                    {place.logo_small && (
                        <div className="logo" style={{backgroundImage: `url("${place.logo_small}")`}}></div>
                    )}
                    <div className="d-flex flex-column justify-content-center place-info-container">
                        <h1 className={place.header ? "" : "multiline"}>{place.name}</h1>
                        {place.header && <p>{place.header}</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MultistorePlaceCardCover;